import { combineReducers, configureStore } from "@reduxjs/toolkit";
import appReducer from "./appSlice";

const rootReducer = combineReducers({
  app: appReducer,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => 
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ['app/setUser'],
        // Ignore these field paths in all actions
        ignoredActionsPaths: ['payload.user'],
        // Ignore these paths in the state
        ignoredPaths: ['app.user'],
      },
    }),
});
